import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useOrderState from '@afosto/utils-react/useOrderState';
import usePermissions from '@afosto/utils-react/permissions/usePermissions';
import usePrivate from '@afosto/auth-react/usePrivate';
import useQueryParameters from '@afosto/utils-react/useQueryParameters';
import { useHistory } from 'react-router-dom';
import OrderForm from '../../components/OrderForm';
import OrderFormProvider from '../../components/OrderFormProvider';
import Page from '@afosto/app-components-react/Page';
import translations from './translations';

const CreateOrder = () => {
  usePrivate();

  const history = useHistory();
  const intl = useIntl();
  const [hasPermissions, UnauthorizedComponent] = usePermissions(['odr:orders:write']);
  const { type = 'order' } = useQueryParameters();
  const orderState = useOrderState(null, { type });
  const { order } = orderState;

  if (!hasPermissions()) {
    return (
      <Page title={intl.formatMessage(translations.title[type])}>
        <UnauthorizedComponent />
      </Page>
    );
  }

  return (
    <Page title={intl.formatMessage(translations.title[type])}>
      <OrderFormProvider value={{ ...orderState, type }}>
        <OrderForm onSave={() => history.push(`/orders/${order.id}`)} />
      </OrderFormProvider>
    </Page>
  );
};

export default CreateOrder;
